<template>
    <!-- 个人信息 -->
    <div class="container">
        <div class="icon-style">
            <img class="avatar" :src="headIcon"/>
        </div>
        <div class="item-style">
            <span class="item-text">昵称</span>
            <span class="item-text-right">{{nickName}}</span>
        </div>
        
        <div class="item-style">
            <span class="item-text">用户ID</span>
            <div class="right-style">
                <span class="item-text-right">{{userId}}</span>
                <img class="icon-img" src="@/assets/copy_img.png" @click="getCopy()"/>
            </div>
            
        </div>
    </div>
</template>
  
  <script>
  import { getInfo } from "@/api/user";
  import { Toast } from "vant";
  export default {
    components: {
    },
    data() {
      return {
        headIcon:'',
        nickName:'',
        userId:'',
      };
    },
  
    mounted() {
        this.getUserInfo();
    },
  
    methods: {
        getUserInfo() {
            getInfo()
                .then((res) => {
                    console.log(res);
                    this.headIcon = res.avatar;
                    this.nickName = res.name;
                    this.userId = res.userId;
                })
                .catch((err) => {
                    console.error("获取信息失败：" + err);
                });
        },
        getCopy(){
            navigator.clipboard.writeText(this.userId);
            Toast.success("复制成功");
        }

    },
  };
  </script>
   
  <style lang="less" scoped>

   .container {
       background: white;
       padding-left: 20px;
       padding-right: 20px;
       padding-top: 20px;
       .icon-style{
            display: flex;
            width: 100%;
            justify-content: center;
            margin-bottom: 40px;
            .avatar{
                width: 156px;
                height: 156rpx;
                border-radius: 50%;
                margin-top: 40px;
            }
       }
       .item-style{
        display: flex;
        justify-content: space-between;
        padding-left: 32px;
        padding-right: 32px;
        padding-bottom: 34px;
        padding-top: 34px;
        .item-text{
            font-size: 30px;
            color: #24262B;
        }
        .right-style{
            display: flex;
            flex-direction: row;
            align-items: center;
            .icon-img{
                width: 32px;
                height: 32px;
                margin-left: 8px;
            }
        }
        .item-text-right{
            font-size: 30px;
            color: #848992;
        }
          
       }
       

      
   }

  </style>

